import React from 'react';
import Responsive from '@amzn/meridian/responsive';
import { responsiveProps } from 'src/constants/responsiveProps';
import Column from '@amzn/meridian/column';
import Breadcrumb, { BreadcrumbGroup } from '@amzn/meridian/breadcrumb';
import Icon from '@amzn/meridian/icon';
import searchTokens from '@amzn/meridian-tokens/base/icon/search';
import * as AppStrings from 'src/localization/string-ids/app-strings';
import * as AppRoutes from 'src/routing/constants/routes';
import { SearchIcons } from 'src/constants/general-media';
import BarcodeScan from 'src/components/common/barcode-scan/BarcodeScan';
import SearchedContainerDetailsTable from 'src/components/pages/search-page/search-for-laptop/searched-container-details-table/SearchedContainerDetailsTableContainer';
import {
    buildGetContainerDetailsInput,
    GetContainerDetailsInput,
    GetContainerDetailsOutput,
    GetContainerMode
} from 'src/models/GetContainerDetails';
import { isEmpty } from 'src/utils/object-utils';
import UILoader from 'src/components/common/loader/UILoaderContainer';
import StatusAlert from 'src/components/common/status-alert/StatusAlertContainer';
import '../Search.scss';

interface SearchForLaptopStateProps {
    containerDetails?: GetContainerDetailsOutput;
    warehouseId: string,
    associate: string,
    locale: string
}

interface SearchForLaptopDispatchProps {
    fetchContainerDetails: (getContainerDetailsInput: GetContainerDetailsInput) => void;
    resetContainerState: () => void;
}

type Props = SearchForLaptopStateProps & SearchForLaptopDispatchProps;

class SearchForLaptop extends React.Component<Props, any> {

    componentWillUnmount() {
        this.props.resetContainerState();
    }

    private onSubmit = async (containerId: string) => {
        let includeChildren = true;
        await this.props.fetchContainerDetails(buildGetContainerDetailsInput(containerId, this.props.warehouseId,
            this.props.associate, this.props.locale, GetContainerMode.SEARCH, includeChildren));
    }

    public render() {
        const containerId = this.props.containerDetails?.container?.containerId;
        const parentContainerId = this.props.containerDetails?.container?.parentContainer?.containerId;

        return(
            <Responsive query={"max-width"} props={responsiveProps}>
                {props => (
                    <div>
                        <div className={"search-container"}>
                            <BreadcrumbGroup>
                                <Breadcrumb href={AppRoutes.HOME_PAGE_ROUTE}>{AppStrings.HOME}</Breadcrumb>
                                <Breadcrumb href={AppRoutes.SEARCH_PAGE_ROUTE}>{AppStrings.SEARCH}</Breadcrumb>
                            </BreadcrumbGroup>

                            <BarcodeScan
                                shouldRenderImageOrIcon={isEmpty(this.props.containerDetails)}
                                scanImageOrIcon={SearchIcons.SEARCH_MAGNIFYING_GLASS}
                                shouldRenderText={isEmpty(this.props.containerDetails)}
                                scanText={AppStrings.SEARCH_CENTER_TEXT}
                                inputLabel={AppStrings.SEARCH_INPUT_LABEL}
                                inputPlaceholder={AppStrings.SEARCH_INPUT_PLACEHOLDER}
                                shouldRenderButton={true}
                                buttonText={AppStrings.SEARCH_BUTTON_TEXT}
                                buttonIcon={<Icon tokens={searchTokens}/>}
                                onSubmit={this.onSubmit}
                                headingTestId="search-heading"
                                inputTestId="search-input"
                                buttonTestId="search-submit-button"
                            />

                            <div className={"loader-and-alert"}>
                                <UILoader />
                                <StatusAlert />
                            </div>
                        </div>

                        <Column className={"searched-container-details"}>
                            {parentContainerId &&
                                <BreadcrumbGroup>
                                    {parentContainerId &&
                                        <Breadcrumb onClick={() => this.onSubmit(parentContainerId)}>
                                            {parentContainerId}
                                        </Breadcrumb>
                                    }
                                    <Breadcrumb>{containerId}</Breadcrumb>
                                </BreadcrumbGroup>
                            }

                            {this.props.containerDetails?.container &&
                                <SearchedContainerDetailsTable
                                    renderForChildContainers={false}
                                />
                            }
                        </Column>

                        <Column className={"searched-container-details"}>
                            {this.props.containerDetails?.childContainers &&
                                <SearchedContainerDetailsTable
                                    renderForChildContainers={true}
                                />
                            }
                        </Column>
                    </div>
                )}
            </Responsive>
        );
    }
}

export default SearchForLaptop;
